// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__oEREU","actionsCol":"EnrolledClinics_actionsCol__azq02"};